import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Home.css';

function Home() {
  const [homeData, setHomeData] = useState(null);

  useEffect(() => {
    // Fetch the data from the JSON file using Axios
    axios.get('/data/data.json')
      .then((response) => {
        setHomeData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching home data:', error);
      });
  }, []);

  if (!homeData) {
    return <div style={{textAlign: 'center'}}>Loading Home Screen...</div>; // Loading state until the data is fetched
  }

  return (
    <section className="home" id="home">
      <div className="home__container container grid">
        <div className="home__social">
          <span className="home__social-follow">Follow Me</span>
          <div className="home__social-links">
            <a href={homeData.socialMedia.facebook} target="_blank" rel="noreferrer" className="home__social-link">
              <i className="uil uil-facebook-f"></i>
            </a>
            <a href={homeData.socialMedia.github} target="_blank" rel="noreferrer" className="home__social-link">
              <i className="uil uil-github"></i>
            </a>
            <a href={homeData.socialMedia.twitter} target="_blank" rel="noreferrer" className="home__social-link">
              <i className="uil uil-twitter"></i>
            </a>
          </div>
        </div>

        <img 
          src={homeData.profileImage} 
          alt="Profile" 
          className="home__img" 
          style={{ borderRadius: '48% 52% 49% 51% / 42% 42% 58% 58%' }} 
        />

        <div className="home__data">
          <h1 className="home__title">Hi, I'am {homeData.name}</h1>
          <h3 className="home__subtitle">{homeData.title}</h3>
          <p className="home__description">{homeData.description}</p>
          <a href="#about" className="button">
            <i className="uil uil-user button__icon"></i>More About Me
          </a>
        </div>

        <div className="my__info">
          <div className="info__item">
            <i className="uil uil-linkedin info__icon"></i>
            <a href={homeData.contacts.linkedin.url}>
              <div>
                <h3 className="info__title">LinkedIn</h3>
                <span className="info__subtitle">{homeData.contacts.linkedin.name}</span>
              </div>
            </a>
          </div>

          <div className="info__item">
            <i className="uil uil-whatsapp info__icon"></i>
            <a href={homeData.contacts.whatsapp.url}>
              <div>
                <h3 className="info__title">WhatsApp</h3>
                <span className="info__subtitle">{homeData.contacts.whatsapp.phone}</span>
              </div>
            </a>
          </div>

          <div className="info__item">
            <i className="uil uil-envelope-edit info__icon"></i>
            <a href={homeData.contacts.email.url}>
              <div>
                <h3 className="info__title">Email</h3>
                <span className="info__subtitle">{homeData.contacts.email.address}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
